export enum CategoryFilterExamsEnum {
	ALL = 'all',
	IMAGE = 'imagem',
	LAB = 'laboratorial',
}
